<main class="main">
  <div class="main-content">
    <div class="dash-heading">
      <div class="dash-heading-icon"><i class="fas fa-gear"></i></div>
      <div>
        <h1 class="main-title">{{ 'SYSTEM.TITLE' | translate }}</h1>
        <p class="main-subtitle">{{ 'SYSTEM.SUBTITLE' | translate }}</p>
      </div>
    </div>

    <h2 class="section-title">{{ 'SYSTEM.FUNCTIONALITIES.TITLE' | translate }}</h2>
    <div class="card-container">
      <a class="card cat-blue" [routerLink]="'/webhook-management'" *ngIf="functionService.canRead('webhook-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-plug"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.WEBHOOK_MANAGEMENT.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.WEBHOOK_MANAGEMENT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-cyan" [routerLink]="'/data-exchange-management'" *ngIf="functionService.canRead('data-exchange-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-exchange-alt"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.DATA_EXCHANGE_MANAGEMENT.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.DATA_EXCHANGE_MANAGEMENT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-orange" [routerLink]="'/otm-management'" *ngIf="functionService.canRead('otm-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-truck-loading"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.OTM_MANAGEMENT.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.OTM_MANAGEMENT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-green" [routerLink]="'/eod-report'" *ngIf="functionService.canRead('eod-report')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-file-invoice"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.EOD_REPORT.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.EOD_REPORT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-purple" [routerLink]="'/pdf-management'" *ngIf="functionService.canRead('pdf-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-file-pdf"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.PDF_MANAGEMENT.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.PDF_MANAGEMENT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <!-- Generazione esempio di bolla: solo frontend, admin o funzione dedicata -->
      <a class="card cat-orange" [routerLink]="'/waybill-example'" *ngIf="functionService.canRead('waybill-example')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-file-signature"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.WAYBILL_EXAMPLE.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.WAYBILL_EXAMPLE.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-teal" [routerLink]="'/print-documents'" *ngIf="functionService.canRead('print-documents')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-print"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.PRINT_DOCUMENTS.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.PRINT_DOCUMENTS.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-blue" [routerLink]="'/barcode-generator'" *ngIf="functionService.canRead('barcode-generator')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-barcode"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.BARCODE_GENERATOR.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.BARCODE_GENERATOR.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-cyan" [routerLink]="'/calculator-clock'">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-calculator"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.CALCULATOR_CLOCK.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.CALCULATOR_CLOCK.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-orange" [routerLink]="'/logistics-converter'">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-right-left"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.LOGISTICS_CONVERTER.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.LOGISTICS_CONVERTER.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-green" [routerLink]="'/system-monitoring'" *ngIf="functionService.canRead('system-monitoring')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-heartbeat"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.SYSTEM_MONITORING.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.SYSTEM_MONITORING.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-green" [routerLink]="'/zone-region'" *ngIf="functionService.canRead('zone-region')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-map-marked-alt"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.ZONE_REGION.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.ZONE_REGION.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-purple" [routerLink]="'/dealer-massive-insert'" *ngIf="functionService.canRead('dealer-massive-insert')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-file-excel"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.DEALER_MASSIVE_INSERT.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.DEALER_MASSIVE_INSERT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>

      <a class="card cat-purple" [routerLink]="'/private/tracking'">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-map-marker-alt"></i></div>
          <div class="card-text">
            <h3>{{ 'SYSTEM.CARDS.TRACKING.TITLE' | translate }}</h3>
            <p>{{ 'SYSTEM.CARDS.TRACKING.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
    </div>
  </div>
</main>
